<template>
  <div id="list">
    <h2>アップロードリスト</h2>
    <p>ログインすることでアップロードしたファイルが表示されます。</p>
    <hr>
    <div>
      <div v-for="(files, fi) in this.files" :key="fi" class="tile is-ancestor">
        <div v-for="(file, si) in files" :key="si" class="gallery">
          <div v-if="si === 0" class="tile is-parent">
            <article class="tile is-child box">
              <p class="title">アップロード名：{{ file.file_name }}</p>
              <p class="title">オリジナル名：{{ file.original_file_name }}</p>
              <div class="content">
                <router-link v-bind:to="{ name: 'Show', params: { file_name: file.file_name }}">
                  <img style="width:100px"
                       v-lazy="'https://files-uploader.xzy.pw/upload/' + file.file_name + '?show=true'" alt="アップロード">
                </router-link>
              </div>
            </article>
          </div>
          <div v-if="si === 1" class="tile is-parent">
            <article class="tile is-child box">
              <p class="title">アップロード名：{{ file.file_name }}</p>
              <p class="title">オリジナル名：{{ file.original_file_name }}</p>
              <div class="content">
                <router-link v-bind:to="{ name: 'Show', params: { file_name: file.file_name }}">
                  <img style="width:100px"
                       v-lazy="'https://files-uploader.xzy.pw/upload/' + file.file_name + '?show=true'" alt="アップロード">
                </router-link>
              </div>
            </article>
          </div>
          <div v-if="si === 2" class="tile is-parent">
            <article class="tile is-child box">
              <p class="title">アップロード名：{{ file.file_name }}</p>
              <p class="title">オリジナル名：{{ file.original_file_name }}</p>
              <div class="content">
                <router-link v-bind:to="{ name: 'Show', params: { file_name: file.file_name }}">
                  <img style="width:100px"
                       v-lazy="'https://files-uploader.xzy.pw/upload/' + file.file_name + '?show=true'" alt="アップロード">
                </router-link>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'List',
  data () {
    return {
      files: []
    }
  },
  created: function () {
    this.$axios.get(this.baseURL + '/get_files', {
      withCredentials: true
    }).then(response => {
      const devide = function (myArray) {
        let index = 0
        let arrayLength = myArray.length
        let tempArray = []

        for (index = 0; index < arrayLength; index += 3) {
          let myChunk = myArray.slice(index, index + 3)
          // Do something if you want with the group
          tempArray.push(myChunk)
        }
        return tempArray
      }
      this.files = devide(response.data)
    }).catch(() => {
    })
  }
}
</script>

<style scoped>
  .gallery {
    padding: 1rem;
    margin: 0 -1.5rem -1.5rem 0;
    background-color: #404b69;
  }
  .tile.is-ancestor:not(:last-child) {
    margin: 0;
  }
  .title {
    font-size: 1rem;
    color: #404b69;
  }
</style>



// WEBPACK FOOTER //
// src/components/List.vue